import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import * as CartUtils from "@omni/utils/cart.utils";
import { useMemo } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

import PriceLine from "./priceLine/priceLine.component";

type Props = {
    cart: Cart;
};

const PriceSummary = ({ cart }: Props) => {
    const { t } = useGranite();

    const renderDeliveryCost = useMemo(
        () =>
            cart?.items.some(
                (i) =>
                    i.deliveryType === DeliveryType.HomeDelivery &&
                    !CartUtils.productIsAdditionalService(cart?.items, i.id)
            ),
        [cart]
    );

    const discountTotal = CartUtils.getDiscountTotal(cart);
    const giftCardTotal = CartUtils.getGiftCardTotal(cart);

    return (
        <>
            <PriceLine
                title={t("general.cart.totals.subTotal")}
                price={formatPrice(cart.subTotalPrice)}
                borderWeight={0}
            />
            {renderDeliveryCost && (
                <PriceLine
                    title={t("general.cart.totals.deliveryCost")}
                    price={formatPrice(cart.deliveryCost, {
                        freeLabel: true,
                        t: t
                    })}
                />
            )}
            {discountTotal && (
                <PriceLine
                    title={t("general.cart.totals.globalDiscounts")}
                    price={`-${formatPrice(discountTotal)}`}
                />
            )}
            {giftCardTotal && (
                <PriceLine
                    title={t("general.cart.totals.giftCards")}
                    price={`-${formatPrice(giftCardTotal)}`}
                />
            )}

            <div className="font-weight-bold">
                <PriceLine
                    isTotalPrice={true}
                    title={t("general.cart.totals.total")}
                    price={formatPrice(cart.totalPrice)}
                    borderWeight={3}
                    test="priceLine-total"
                />
            </div>
        </>
    );
};

export default PriceSummary;
